import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import AgentSetup from './AgentSetup';

interface Props {
  secret: string;
  hostKey?: string | null;
  onClose: () => void;
}

const AgentSecretDialog = ({ secret, hostKey, onClose }: Props) => {
  const { t } = useTranslation();
  const [copyStatus, setCopyStatus] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      setCopyStatus(t('Copied!'));
    } catch {
      setCopyStatus(t('AGENT_COPY_ERROR'));
    }
  };
  return (
    <Modal
      visible
      title={t('AGENT_SECRET')}
      onCancel={onClose}
      maskClosable={false}
      destroyOnClose
      footer={<Button type="primary" onClick={onClose}>{t('AGENT_SAVED')}</Button>}
    >
      <p>{t('AGENT_ONCE')}</p>
      <input className="agent-secret-value" aria-label={t('AGENT_SECRET')} value={secret} readOnly autoComplete="off" />
      <Button onClick={copy}>{t('AGENT_COPY')}</Button>
      <p role="status">{copyStatus}</p>
      <AgentSetup hostKey={hostKey} secret={secret} />
    </Modal>
  );
};

export default AgentSecretDialog;
